export default function Footer({ setActiveTab }) {
  const services = [
    { title: "Web Development", link: "/services/web-development" },
    { title: "Cloud Solutions", link: "/services/cloud-solutions" },
    { title: "Software Development", link: "/services/software-development" },
    { title: "App Development", link: "/services/app-development" }
  ]; 
  
    return (
      <footer className="bg-gray-900 text-white pt-16 pb-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
            <div>
              <div className="flex items-center mb-4">
                <i className="fas fa-code text-blue-400 text-2xl mr-2"></i>
                <span className="text-xl font-bold text-blue-400">Devs<span className="text-blue-300">Ke</span></span>
              </div>
              <p className="text-gray-400 mb-4">Innovative technology solutions for World's digital transformation.</p>
              <div className="flex space-x-4">
                <a 
                  href="https://twitter.com/devske" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-blue-400 transition duration-300"
                  aria-label="Twitter"
                >
                  <i className="fab fa-twitter text-xl"></i>
                </a>
                <a 
                  href="https://linkedin.com/company/devske" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-blue-400 transition duration-300"
                  aria-label="LinkedIn"
                >
                  <i className="fab fa-linkedin text-xl"></i>
                </a>
                <a 
                  href="https://facebook.com/devske" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-blue-400 transition duration-300"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook text-xl"></i>
                </a>
                <a 
                  href="https://instagram.com/devske" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-blue-400 transition duration-300"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram text-xl"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h3 className="text-lg font-bold text-white mb-4">Services</h3>
              <ul className="space-y-2">
                {services.slice(0, 4).map((service, index) => (
                  <li key={index}>
                    <button 
                      onClick={() => setActiveTab('services')} 
                      className="text-gray-400 hover:text-blue-400 transition duration-300 text-left"
                    >
                      {service.title}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-bold text-white mb-4">Company</h3>
              <ul className="space-y-2">
                <li>
                  <button 
                    onClick={() => setActiveTab('about')} 
                    className="text-gray-400 hover:text-blue-400 transition duration-300"
                  >
                    About Us
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => setActiveTab('contact')} 
                    className="text-gray-400 hover:text-blue-400 transition duration-300"
                  >
                    Contact
                  </button>
                </li>
                <li>
                  <a 
                    href="/careers" 
                    className="text-gray-400 hover:text-blue-400 transition duration-300"
                  >
                    Careers
                  </a>
                </li>
                <li>
                  <a 
                    href="/blog" 
                    className="text-gray-400 hover:text-blue-400 transition duration-300"
                  >
                    Blog
                  </a>
                </li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-bold text-white mb-4">Contact Info</h3>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-start">
                  <i className="fas fa-map-marker-alt mt-1 mr-3 text-blue-400"></i>
                  <span>Nairobi Business Park, Ngong Road, Nairobi</span>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-phone-alt mr-3 text-blue-400"></i>
                  <span>+254 112 120 270</span>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-envelope mr-3 text-blue-400"></i>
                  <span>info@devsinkenya.com</span>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 mb-4 md:mb-0">© {new Date().getFullYear()} DevsKe. All rights reserved.</p>
              <div className="flex space-x-6">
                <a 
                  href="/privacy-policy" 
                  className="text-gray-400 hover:text-blue-400 transition duration-300"
                >
                  Privacy Policy
                </a>
                <a 
                  href="/terms-of-service" 
                  className="text-gray-400 hover:text-blue-400 transition duration-300"
                >
                  Terms of Service
                </a>
                <a 
                  href="/sitemap" 
                  className="text-gray-400 hover:text-blue-400 transition duration-300"
                >
                  Sitemap
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }